<nav class="navbar shadow navbar-expand-md navbar-light bg-white" style="margin-top: 25px;">
  <div class="container-fluid align-items-center">
    <!-- Logo on the left -->
    <div class="col-2">

      <img (click)="toggleLanguage();close()" class="img-fluid changelang" src="/assets/changeLanguage.png"
        alt="change language button image" />




    </div>
    <a class="col-4" routerLink="/Home.mobile">
      <img src="/assets/logo-mobile.png" class="card-img w-25" alt="Logo" height="30" />
    </a>

    <button class="navbar-toggler mobile-menu-btn" style="padding: 0;" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarNav" aria-controls="navbarNav" (click)="openMenuToggle()" aria-expanded="false"
      aria-label="Toggle navigation">

      <i class="fa-solid fa-bars"></i>

    </button>


  </div>
</nav>



<div *ngIf="openMenu" class="popup">

  <div class="maindev">
    <button (click)='close()' class="close btn btn-primary "> {{ "close" | transloco }} </button>

    <div class="mobile-menu">

      <ul class="navbar-nav ms-auto col-12 col-md-6 justify-content-end">



        <li class="nav-item" (click)='close()' routerLink="/orders.mobile">
          <img src="/assets/add.png" class="imagessize" routerLink="/orders.mobile" alt="add item" />

          <a routerLink="/orders.mobile" class="text-decoration-none nav-link" routerLinkActive="active">{{ "Orders" |
            transloco }}</a>
        </li>
        <li class="nav-item" (click)='close()' routerLink="/Profile">
          <img class="imagessize" src="/assets/profile.png" alt="profile" routerLink="/Profile" />
          <a class="text-decoration-none nav-link" routerLink="/Profile" routerLinkActive="active">{{ "Profile" |
            transloco }}</a>
        </li>



        <ng-container>



          <li class="nav-item" (click)='close()' routerLink="/Pospage.mobile">
            <img src="/assets/Home.png" routerLink="/Pospage.mobile" class="imagessize" alt="home" />
            <a class="text-decoration-none nav-link" routerLink="/Pospage.mobile" routerLinkActive="active">{{ "Pospage"
              |
              transloco }}</a>
          </li>

          <li class="nav-item" (click)='close()' routerLink="/Home.mobile">
            <img src="/assets/stock.png" routerLink="/Home.mobile" class="imagessize" alt="home" />
            <a class="text-decoration-none nav-link" routerLink="/Home.mobile" routerLinkActive="active">{{ "Stock" |
              transloco }}</a>
          </li>


          <li class="nav-item" (click)='close()' routerLink="/Home.mobile">
            <img src="/assets/products.png" routerLink="/Home.mobile" class="imagessize" alt="home" />
            <a class="text-decoration-none nav-link" routerLink="/Home.mobile" routerLinkActive="active">{{ "products" |
              transloco }}</a>
          </li>


          <li class="nav-item" (click)='close()' routerLink="/orders.mobile">
            <img src="/assets/add.png" class="imagessize" routerLink="/orders.mobile" alt="add item" />

            <a routerLink="/orders.mobile" class="text-decoration-none nav-link" routerLinkActive="active">{{ "Orders" |
              transloco }}</a>
          </li>



          <li class="nav-item" (click)='close()' routerLink="/deliverymanager.mobile">
            <img src="/assets/ontheway.png" class="imagessize" routerLink="/deliverymanager.mobile" alt="add item" />

            <a routerLink="/deliverymanager.mobile" class="text-decoration-none nav-link" routerLinkActive="active">
              {{ "delivery" | transloco }}</a>
          </li>

          <li class="nav-item" (click)='close()' routerLink="/suppliespage.mobile">
            <img src="/assets/sup.png" class="imagessize" routerLink="/suppliespage.mobile" alt="add item" />

            <a routerLink="/suppliespage.mobile" class="text-decoration-none nav-link" routerLinkActive="active">{{
              "supplies"
              | transloco }}</a>
          </li>



          <li class="nav-item" (click)='close()' routerLink="/myclients.mobile">
            <img src="/assets/phone.png" class="imagessize" routerLink="/myclients.mobile" alt="clients" />

            <a routerLink="/myclients.mobile" class="text-decoration-none nav-link" routerLinkActive="active"> {{
              "myclients" |
              transloco }}</a>
          </li>


          <li class="nav-item" (click)='close()' routerLink="/dailyexpenses">
            <img routerLink="/dailyexpenses" class="imagessize" src="/assets/card photo.png" alt="profile" />

            <a class="text-decoration-none nav-link" routerLink="/dailyexpenses" routerLinkActive="active">{{
              "financial" |
              transloco }}</a>
          </li>

          <li class="nav-item" (click)='close()' routerLink="/financial-manager.moblie">
            <img routerLink="/financial-manager.moblie" class="imagessize" src="/assets/income.png" alt="profile" />

            <a class="text-decoration-none nav-link" routerLink="/financial-manager.moblie" routerLinkActive="active">{{
              "income" |
              transloco }}</a>
          </li>





          <li class="nav-item" (click)='close()' routerLink="/employeepage.mobile">
            <img routerLink="/employeepage.mobile" class="imagessize" src="/assets/emploees.png" alt="emploees" />
            <a class="text-decoration-none nav-link" routerLink="/employeepage.mobile" routerLinkActive="active">{{
              'employees' | transloco }}</a>
          </li>


          <li class="nav-item" (click)='close()' routerLink="/allusers.mobile">
            <img routerLink="/allusers.mobile" class="imagessize" src="/assets/profile.png" alt="profile" />
            <a class="text-decoration-none nav-link" routerLink="/allusers.mobile" routerLinkActive="active">{{ "Users"
              | transloco }}</a>
          </li>

          <li class="nav-item" (click)='close()' routerLink="/Profile">
            <img class="imagessize" src="/assets/profile.png" alt="profile" routerLink="/Profile" />
            <a class="text-decoration-none nav-link" routerLink="/Profile" routerLinkActive="active">{{ "Profile" |
              transloco }}</a>
          </li>


        </ng-container>


        <li class="nav-item" (click)='close()' routerLink="/fingerprint">
          <img routerLink="/fingerprint" class="imagessize" src="/assets/fingerprint.png" alt="fingerprint" />
          <a class="text-decoration-none nav-link" routerLink="/fingerprint" routerLinkActive="active">{{
            'fingerprint' | transloco }}</a>
        </li>

        <li class="nav-item cart" *ngIf="isDeliveryHero == false" (click)='close()' routerLink="/Addorder">
          <span *ngIf="cartItemCount > 0" style="font-weight: bolder;">
            {{cartItemCount}}</span>
          <img src="/assets/cart.png" class="imagessize" routerLink="/Addorder" alt="add item" />

          <a routerLink="/Addorder" class="text-decoration-none nav-link" routerLinkActive="active">{{ "Cart" |
            transloco }}</a>
        </li>



        <li class="nav-item" (click)="logout()">
          <img src="/assets/log out 1.png" alt="" class="imagessize" />
          <a class="text-decoration-none nav-link">{{ "Log out" | transloco }}</a>
        </li>


      </ul>
    </div>


  </div>
</div>

<div *ngIf="cartPopUp" class="popup">

  <div class="maindev">
    <button (click)='close()' class="close btn btn-primary"> {{ "close" | transloco }} </button>


    <svg width="800px" height="800px" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20l44 0 0 44c0 11 9 20 20 20s20-9 20-20l0-44 44 0c11 0 20-9 20-20s-9-20-20-20l-44 0 0-44c0-11-9-20-20-20s-20 9-20 20l0 44-44 0c-11 0-20 9-20 20z" />
    </svg>

    <ul *ngFor="let item of cartItems">
      <li>{{item.name_ar}} <span (click)='removeFromCart(item)'>

          <i class="fa-solid fa-square-xmark"></i></span></li>
    </ul>
    <button (click)="quickOrder()" type="submit" class="submit-btn btn btn-primary">
      {{ "proceed to add order" | transloco }}
    </button>



  </div>
</div>